import Box from '@mui/material/Box'
import withWidth from '@mui/material/Hidden/withWidth'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import requestsManagementStore from '../../../stores/RequestsManagementStore'
import { getStyles } from '../../../utils/utils/commonUtils'
import { getComp } from '../../../utils/utils/DI'
import NewRequestFilters from '../components/NewRequestFilters/NewRequestFilters'
import RequestsNotesTableOptimized from '../components/RequestsTableOptimized/RequestsNotesTableOptimized'
import RequestsTableOptimized from '../components/RequestsTableOptimized/RequestsTableOptimized'
import AdministrationTableControls from '../components/utils/AdministrationTableControls'
import requestsManagementStyles from '../styles/requestsManagementStyles'

function AdministrationRequestsPage() {
  const {
    filterStore,
    ordersStore,
    operatorStore,
    selectOrdersStore,
    openAddRequestDrawer,
    openRequestDetails,
    totalCollectionLength,
  } = requestsManagementStore

  const [selectedCol, setSelectedCol] = useState('id')
  const classes = getStyles(requestsManagementStyles)
  const serviceStore = getComp('ServiceStore')

  const { serviceDrawersController, editSelectTab } = serviceStore

  useEffect(() => {
    if (operatorStore.selectedTab === 0) {
      ordersStore.reLoad({
        page: 0,
        size: operatorStore.pageSize,
      })
    }
    if (operatorStore.selectedTab === 1) {
      operatorStore.reLoad({
        page: 0,
        size: operatorStore.pageSize,
      })
    }
  }, [operatorStore.selectedTab])

  useEffect(() => {
    return () => {
      operatorStore.setData([])
    }
  }, [])

  useEffect(() => {
    editSelectTab(operatorStore?.selectedTab)
  }, [operatorStore?.selectedTab])

  const onRowClick = (e) => {
    return operatorStore.selectedTab === 2 || operatorStore.selectedTab === 3
      ? serviceDrawersController(e)
      : openRequestDetails(e)
  }

  return (
    <>
      <AdministrationTableControls
        selectedTab={operatorStore.selectedTab}
        setSelectedTab={operatorStore.setSelectedTab}
        clearFilters={filterStore.clear}
      />
      <NewRequestFilters
        selectOrderCollection={selectOrdersStore?.selectedOrders}
        totalCollectionLength={totalCollectionLength}
        filtersStore={filterStore}
        ordersStore={ordersStore}
        selectOrdersStore={selectOrdersStore}
        openAddRequestDrawer={openAddRequestDrawer}
        operatorStore={operatorStore}
        setSelectedCol={setSelectedCol}
      />
      <Box name={'table'} sx={classes.tableWrapper}>
        {operatorStore.selectedTab === 0 && (
          <RequestsTableOptimized
            selectOrdersStore={selectOrdersStore}
            ordersStore={ordersStore}
            onRowClick={(e) => openRequestDetails(e)}
            withScrollButtons
            selectedCol={selectedCol}
            setSelectedCol={setSelectedCol}
          />
        )}
        {operatorStore.selectedTab === 1 && (
          <RequestsNotesTableOptimized
            operatorsStore={operatorStore}
            onRowClick={onRowClick}
            withScrollButtons
          />
        )}
      </Box>
    </>
  )
}

export default withWidth()(observer(AdministrationRequestsPage))
